"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getChainFullNetworkID = void 0;
const bn_js_1 = __importDefault(require("bn.js"));
const bytes_1 = require("../utils/bytes");
const getChainFullNetworkID = (chain) => {
    // 1 byte: chainType.
    const formattedChainType = (0, bytes_1.formatToByteLength)((0, bytes_1.hexlify)(new bn_js_1.default(chain.type)), bytes_1.ByteLength.UINT_8);
    // 7 bytes: chainID.
    const formattedChainID = (0, bytes_1.formatToByteLength)((0, bytes_1.hexlify)(new bn_js_1.default(chain.id)), bytes_1.ByteLength.UINT_56);
    return `${formattedChainType}${formattedChainID}`;
};
exports.getChainFullNetworkID = getChainFullNetworkID;
